export default {
  NONE: 0,
  NEW: 2,
  VISITED: 3,
  CANCELLED: 5,
  NO_SHOW: 6,
  options: {
    2: '来店待ち',
    3: '来店済み',
    5: 'キャンセル',
    6: '来店なし',
  },
}



// WEBPACK FOOTER //
// ./js/ReservationStatus.js